import { render, staticRenderFns } from "./colorselector.vue?vue&type=template&id=0b9646a9&scoped=true&"
import script from "./colorselector.vue?vue&type=script&lang=js&"
export * from "./colorselector.vue?vue&type=script&lang=js&"
import style0 from "./colorselector.vue?vue&type=style&index=0&id=0b9646a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9646a9",
  null
  
)

export default component.exports